import React from 'react';

import {FormEditModal} from 'components/form-edit-modal/form-edit-modal';
import {Table} from 'components/table';
import {ITableScroll} from 'components/table/table';
import {IPageTemplateProps} from 'pages';

interface IOwnProps extends IPageTemplateProps {
    hideTitle?: boolean;
    referenceUrl: string;
    onClose: () => void;
    scroll?: ITableScroll;
}

export const TableWithOpenForm = ({
    url, hideTitle, entityType, entityName, onClose, referenceUrl, scroll,
}: IOwnProps) => (
    <>
        <Table
            hideTitle={hideTitle}
            entityName={entityName}
            url={url}
            entityType={entityType}
            scroll={scroll}
        />
        <FormEditModal
            entityName={entityName}
            onClose={onClose}
            referenceUrl={referenceUrl}
        />
    </>
);
